import React from 'react';

const Main: React.FC = ({ children }) => {
  return <main className="container mx-auto p-4">
    {children}
    <div className="fixed bottom-0 text-gray-300">Created by me</div>
  </main>
}

export default Main;
